import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { Link } from 'react-router-dom';

const Homepage = () => {
  return (
    <div className="min-h-screen flex items-center justify-center p-4" style={{ backgroundColor: 'rgb(15, 23, 42)' }}>
      <div className="w-full max-w-2xl">
        {/* Header */}
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center mb-4">
            <img 
              src="/icon.png" 
              alt="BCUBE Logo" 
              className="w-16 h-16"
            />
          </div>
          <h1 className="text-3xl font-bold text-white mb-2">b-cube.ai</h1>
        </div>

        {/* Notice */}
        <div className="bg-white/10 backdrop-blur-lg rounded-2xl border border-white/20 shadow-2xl p-8">
          <div className="text-center">
            <div className="w-16 h-16 text-yellow-400 mx-auto mb-4 flex items-center justify-center bg-yellow-400/20 rounded-full">
              <AlertTriangle className="w-8 h-8" />
            </div>
            
            <h2 className="text-2xl font-bold text-white mb-6">Important Notice - EU MiCA Regulation</h2>
            
            <div className="text-slate-300 text-left space-y-4 mb-8">
              <p>
                Due to the full implementation of the EU's MiCA regulation (Markets in Crypto-Assets), 
                we no longer accept new registrations as of May 31st, 2025.
              </p>
              
              <p>
                Our platform will cease operations on June 30th, 2025. We are exploring the possibility 
                of offering our services under a new regulatory framework outside the EU. We will keep 
                you informed of any developments.
              </p>
            </div>

            {/* Link to unstaking for existing users */}
            <div className="pt-6 border-t border-white/20">
              <p className="text-slate-400 mb-4">Existing users can still access unstaking services:</p>
              <Link 
                to="/unstake"
                className="inline-flex items-center px-6 py-3 bg-indigo-600 hover:bg-indigo-700 text-white font-medium rounded-lg transition-colors duration-200"
              >
                Access Unstaking Portal
              </Link>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="text-center mt-6">
          <p className="text-slate-500 text-xs">
            © 2022 - 2025. All Rights Reserved. b-cube.ai s.r.l
          </p>
        </div>
      </div>
    </div>
  );
};

export default Homepage;
